/**
 * 通用混合
 * */
import { getHeaderName, getMenuSider, getSiderSubmenu,getSiderOpenNames} from '@/libs/ab-system';
export default {
    methods: {
        // 当 $route 更新时触发
        appRouteChange (to, from) {
			this.$store.commit('admin/menu/setActivePath', to.path);
			
			this.$store.dispatch('admin/db/database', { user: true }).then((db)=>{
				const menuList = db.get('userMenuList').value();
	        	const headerName = getHeaderName(to.path, menuList,to.fullPath);
	            // 在 404 时，是没有 headerName 的
	            if (headerName) {
	            	//通过headName 取到下属的菜单
			        const menuSider = getMenuSider(menuList,headerName);
			        
		        	this.$store.commit("admin/menu/setSider", menuSider);
	                this.$store.commit('admin/menu/setHeaderName', headerName);
	                // 解决带参数路由无法高亮问题
	                this.$store.commit('admin/menu/setActivePath', to.fullPath);
	                const openNames = getSiderOpenNames(to.fullPath, menuSider);
	                if(openNames.length>0){
		                this.$store.commit('admin/menu/setOpenNames', openNames);
	                }
	           }
			})
        }
    }
}
